// src/components/Contact.js

import React, { useState } from "react";
import "./Contact.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
  faMobile,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import emailjs from "emailjs-com"; // Import EmailJS
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    companyName: "",
    email: "",
    phone: "",
    country: "",
    message: "",
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      name: formData.name,
      companyName: formData.companyName,
      email: formData.email,
      phone: formData.phone,
      country: formData.country,
      message: formData.message,
    };

    emailjs
      .send(
        "service_zvbdk3g", // Replace with your Service ID
        "template_o4uymov", // Replace with your Template ID
        templateParams,
        "NZQO_0MZ0BYGUPHtj" // Replace with your Public Key
      )
      .then(() => {
        setSuccessMessage(t("contact.success"));
        setErrorMessage("");
        setFormData({
          name: "",
          companyName: "",
          email: "",
          phone: "",
          country: "",
          message: "",
        });
      })
      .catch((error) => {
        console.error("Error sending email:", error);
        setErrorMessage(t("contact.error"));
      });
  };

  return (
    <div className="contact-page">
      {/* Form Section */}
      <div className="form-section">
        <h2 className="section-title">{t("contact.title")}</h2>
        <form className="contact-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder={t("contact.name")}
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="companyName"
            placeholder={t("contact.company")}
            value={formData.companyName}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder={t("contact.email")}
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder={t("contact.phone")}
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="country"
            placeholder={t("contact.country")}
            value={formData.country}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder={t("contact.message")}
            value={formData.message}
            onChange={handleChange}
            rows="5"
            required
          ></textarea>
          <button type="submit" className="submit-button">
            {t("contact.send")}
          </button>
        </form>
        {successMessage && (
          <div className="success-message">{successMessage}</div>
        )}
        {errorMessage && <div className="error-message">{errorMessage}</div>}
      </div>

      {/* Contact Info Section */}
      <div className="contact-info-section">
        <h2 className="section-title">{t("contact.title2")}</h2>
        <div className="info-item">
          <FontAwesomeIcon icon={faPhone} className="info-icon" />
          <span>+90 549 575 44 08</span>
        </div>
        <div className="info-item">
          <FontAwesomeIcon icon={faEnvelope} className="info-icon" />
          <a href="mailto:info@krlkimya.com">info@krlkimya.com</a>
        </div>
        <div className="info-item">
          <FontAwesomeIcon icon={faLocationDot} className="info-icon" />
          <a
            href="https://maps.app.goo.gl/Jk8ef54a4V83cGyB8"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("header.contact.address")}
          </a>
        </div>
        <div className="social-media">
          <a
            href="https://www.facebook.com/krlkimya"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faFacebook} className="social-icon" />
          </a>
          <a
            href="https://www.instagram.com/krlkimya"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faInstagram} className="social-icon" />
          </a>
          <a
            href="https://www.linkedin.com/company/krl-kimya"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faLinkedin} className="social-icon" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
